import { type BookmarksInitiativePriorityListAttributes } from './generated/BookmarksInitiativePriorityListAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import Initiative from './Initiative';
import {
  HasBookmarksPriorityList,
  projectWorkflowScope,
} from './concerns/HasBookmarksPriorityList';
import { type RecordId } from 'javascripts/shared-types';

interface BookmarksInitiativePriorityList
  extends BookmarksInitiativePriorityListAttributes,
    HasBookmarksPriorityList {}

@model
@HasBookmarksPriorityList
class BookmarksInitiativePriorityList extends ApplicationModel {
  // Start auto-generated
  static typename: 'BookmarksInitiativePriorityList' =
    'BookmarksInitiativePriorityList';
  get typename(): 'BookmarksInitiativePriorityList' {
    return 'BookmarksInitiativePriorityList';
  }

  static internalTypename: 'Bookmarks::InitiativePriorityList' =
    'Bookmarks::InitiativePriorityList';
  get internalTypename(): 'Bookmarks::InitiativePriorityList' {
    return 'Bookmarks::InitiativePriorityList';
  }

  static bookmarkName = 'Bookmarks::InitiativePriorityList';

  static inputType = 'PriorityListAttributes!';

  static fields = {
    advancedFilters: attr({ readable: true }),
    advancedFiltersParsed: attr({ readable: true, json: true }),
    clearFilters: attr({ writable: true, readable: false }),
    columnTables: attr({ readable: true, json: true }),
    filters: attr({ readable: true }),
    hasShippableRecords: attr({ readable: true }),
    id: attr({ readable: true }),
    joins: attr({ readable: true, json: true }),
    projectId: attr({ readable: true }),
    totalPrioritizedRecords: attr({ readable: true }),
    totalUnprioritizedRecords: attr({ readable: true }),
    userAllowedToPublishRanks: attr({ readable: true }),
    cardLayout: attr.belongsTo({ readable: true, typename: 'CardLayout' }),
    defaultCardLayout: attr.belongsTo({
      readable: true,
      typename: 'CardLayout',
    }),
    lastPublishedField: attr.belongsTo({
      readable: true,
      typename: 'CustomFieldDefinition',
    }),
    prioritizedRow: attr.belongsTo({ readable: true, typename: 'PivotRow' }),
    prioritizedRows: attr.belongsTo({
      args: { page: 'Int', per: 'Int' },
      readable: true,
      typename: 'PivotRowPage',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    columnWidths: attr.hasMany({ writable: true, readable: true }),
    columns: attr.hasMany({ writable: true, readable: true }),
    lineBreaks: attr.hasMany({ writable: true, readable: true }),
    publishableCustomFields: attr.hasMany({ readable: true }),
    scoringSystemMetrics: attr.hasMany({ readable: true }),
    unprioritizedRecords: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  static get updateFragmentName() {
    return 'updateBookmarksInitiativePriorityList';
  }

  static get bookmarkType() {
    return 'Bookmarks::InitiativePriorityList';
  }

  static get recordType() {
    return Initiative;
  }

  get cardView() {
    return this.cardLayout.initiativeRecordLayout.expanded;
  }

  static async getWorkflowsForProjects(projectIds: RecordId[]) {
    return projectWorkflowScope([Initiative.typename])
      .where({ id: projectIds })
      .all();
  }
}

export default BookmarksInitiativePriorityList;
